import { openBlock as r, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return r(), o("svg", n, [...e[0] || (e[0] = [
    t("path", {
      stroke: "currentColor",
      d: "M20 12.5V5H3v13h11.5m3.493-5.5v7m3.507-3.507h-7"
    }, null, -1),
    t("path", {
      stroke: "currentColor",
      d: "m5 13 5-3.5 1.5 2 6-4"
    }, null, -1)
  ])]);
}
const m = { render: l };
export {
  m as default,
  l as render
};
